import IconProps from './IconProps';
import VectorIcon from './VectorIcon';

const AgentIcon = ({ width = 30, height = 24 }: IconProps): JSX.Element => (
  <VectorIcon width={width} height={height}>
    <path
      d="M21.75 5H16.5V1.625C16.5 1.00344 15.9966 0.5 15.375 0.5H8.625C8.00344 0.5 7.5 1.00344 7.5 1.625V5H2.25C1.00734 5 0 6.00734 0 7.25V19.25C0 20.4927 1.00734 21.5 2.25 21.5H21.75C22.9927 21.5 24 20.4927 24 19.25V7.25C24 6.00734 22.9927 5 21.75 5ZM9 2H15V5H9V2ZM22.5 19.25C22.5 19.6634 22.1634 20 21.75 20H2.25C1.83656 20 1.5 19.6634 1.5 19.25V12.5H9V14.375C9 14.9961 9.50391 15.5 10.125 15.5H13.875C14.4961 15.5 15 14.9961 15 14.375V12.5H22.5V19.25ZM10.5 14V12.5H13.5V14H10.5ZM22.5 11H1.5V7.25C1.5 6.83656 1.83656 6.5 2.25 6.5H21.75C22.1634 6.5 22.5 6.83656 22.5 7.25V11Z"
      fill="#0D2E68"
    />
  </VectorIcon>
);

export default AgentIcon;
